import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Investors\ProjectsController::submit
* @see app/Http/Controllers/Investors/ProjectsController.php:123
* @route '//app.finesthub.de/financing-requests/{project}/submit'
*/
export const submit = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

submit.definition = {
    methods: ["post"],
    url: '//app.finesthub.de/financing-requests/{project}/submit',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Investors\ProjectsController::submit
* @see app/Http/Controllers/Investors/ProjectsController.php:123
* @route '//app.finesthub.de/financing-requests/{project}/submit'
*/
submit.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return submit.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProjectsController::submit
* @see app/Http/Controllers/Investors/ProjectsController.php:123
* @route '//app.finesthub.de/financing-requests/{project}/submit'
*/
submit.post = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: submit.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Investors\ProjectsController::index
* @see app/Http/Controllers/Investors/ProjectsController.php:31
* @route '//app.finesthub.de/financing-requests'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/financing-requests',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\ProjectsController::index
* @see app/Http/Controllers/Investors/ProjectsController.php:31
* @route '//app.finesthub.de/financing-requests'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProjectsController::index
* @see app/Http/Controllers/Investors/ProjectsController.php:31
* @route '//app.finesthub.de/financing-requests'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\ProjectsController::index
* @see app/Http/Controllers/Investors/ProjectsController.php:31
* @route '//app.finesthub.de/financing-requests'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\ProjectsController::show
* @see app/Http/Controllers/Investors/ProjectsController.php:44
* @route '//app.finesthub.de/financing-requests/{project}'
*/
export const show = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: '//app.finesthub.de/financing-requests/{project}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Investors\ProjectsController::show
* @see app/Http/Controllers/Investors/ProjectsController.php:44
* @route '//app.finesthub.de/financing-requests/{project}'
*/
show.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return show.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProjectsController::show
* @see app/Http/Controllers/Investors/ProjectsController.php:44
* @route '//app.finesthub.de/financing-requests/{project}'
*/
show.get = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Investors\ProjectsController::show
* @see app/Http/Controllers/Investors/ProjectsController.php:44
* @route '//app.finesthub.de/financing-requests/{project}'
*/
show.head = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Investors\ProjectsController::update
* @see app/Http/Controllers/Investors/ProjectsController.php:85
* @route '//app.finesthub.de/financing-requests/{project}'
*/
export const update = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put","patch"],
    url: '//app.finesthub.de/financing-requests/{project}',
} satisfies RouteDefinition<["put","patch"]>

/**
* @see \App\Http\Controllers\Investors\ProjectsController::update
* @see app/Http/Controllers/Investors/ProjectsController.php:85
* @route '//app.finesthub.de/financing-requests/{project}'
*/
update.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return update.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProjectsController::update
* @see app/Http/Controllers/Investors/ProjectsController.php:85
* @route '//app.finesthub.de/financing-requests/{project}'
*/
update.put = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Investors\ProjectsController::update
* @see app/Http/Controllers/Investors/ProjectsController.php:85
* @route '//app.finesthub.de/financing-requests/{project}'
*/
update.patch = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'patch'> => ({
    url: update.url(args, options),
    method: 'patch',
})

/**
* @see \App\Http\Controllers\Investors\ProjectsController::destroy
* @see app/Http/Controllers/Investors/ProjectsController.php:112
* @route '//app.finesthub.de/financing-requests/{project}'
*/
export const destroy = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '//app.finesthub.de/financing-requests/{project}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Investors\ProjectsController::destroy
* @see app/Http/Controllers/Investors/ProjectsController.php:112
* @route '//app.finesthub.de/financing-requests/{project}'
*/
destroy.url = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { project: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { project: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            project: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        project: typeof args.project === 'object'
        ? args.project.id
        : args.project,
    }

    return destroy.definition.url
            .replace('{project}', parsedArgs.project.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Investors\ProjectsController::destroy
* @see app/Http/Controllers/Investors/ProjectsController.php:112
* @route '//app.finesthub.de/financing-requests/{project}'
*/
destroy.delete = (args: { project: string | number | { id: string | number } } | [project: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const ProjectsController = { submit, index, show, update, destroy }

export default ProjectsController